import { toast } from 'libs/toast'

// Backend `detail` returned by the gateway when an account has no accessible
// active surveys (service_gateway mixins get_active_accessible_survey_tokens).
export const NO_SURVEY_ACCESS_DETAIL = 'No survey access.'

export const NO_SURVEY_ACCESS_USER_MESSAGE =
  'You don’t have access to any surveys. Contact your workspace admin.'

export function isNoSurveyAccessError(error) {
  return (
    error?.response?.status === 403 && error?.response?.data?.detail === NO_SURVEY_ACCESS_DETAIL
  )
}

export function notifyNoSurveyAccess() {
  toast.error(NO_SURVEY_ACCESS_USER_MESSAGE)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/api-errors/index.js